
const plans = {
  start: {
    row_idx: 0,
    price: 9.0,
    annual_price: 84.0,//90.0,
    name: "Start",
    description: 'Grow fast',
    benefits: [
      '3 Pages',
      '2 Rich links per page',
      'Direct messenger button per page',
    ],
    hide: true
  },
  smart: {
    row_idx: 1,
    price: 6.0,
    annual_price: 60.0,
    name: "Smart",
    description: 'Stunning Page',
    benefits: [
      '50 Rich links per page',
      'Direct messenger buttons',
      '🤑 Shor Rewards'
    ],
    hide: true
  },
  rocket: {
    row_idx: 2,
    price: 15.0,
    annual_price: 144.0,//150.0,
    name: "Rocket",
    description: 'Boost your convertions',
    benefits: [
      '5 Pages',
      '10 Rich links per page',
      'Multiple messenger buttons on page',
    ]
  },
  pro: {
    row_idx: 3,
    price: 29.0,
    annual_price: 288.0,//290.0,
    name: "Pro",
    description: 'Analyze and improve', //  fine tuning
    benefits: [
      'Google Analytics and Ad Tracking platforms',
      '50 Pages',
      '50 Rich links',
      '5 Dynamic feeds'
    ]
  },
  agency: {
    row_idx: 4,
    price: 99.0,
    annual_price: 984.0,//990.0,
    name: "Agency",
    description: 'Projects and Teams',
    // stripe_id: 'agency2019',
    benefits: [
      '3+ projects',
      '10 team members per project',
      '250 Pages',
      '5 Dynamic feeds',
    ]
  }
}


const plansBF2019 = {}

// const plansBF2019 = {
//   start: {
//     row_idx: 0,
//     price: 9.0,
//     annual_price: 54.0,//90.0,
//     annual_then_price: plans['start'].annual_price,
//     name: "Start",
//     description: 'Grow fast',
//     benefits: [
//       '3 Pages',
//       '2 Rich links per page',
//       'Direct messenger button per page',
//     ]
//   },
//   rocket: {
//     row_idx: 1,
//     price: 15.0,
//     annual_price: 90.0,//150.0,
//     annual_then_price: plans['rocket'].annual_price,
//     name: "Rocket",
//     description: 'Boost your convertions',
//     benefits: [
//       '5 Pages',
//       '10 Rich links per page',
//       'Multiple messenger buttons on page',
//     ]
//   },
//   pro: {
//     row_idx: 2,
//     price: 29.0,
//     annual_price: 174.0,//290.0,
//     annual_then_price: plans['pro'].annual_price,
//     name: "Pro",
//     description: 'Analyze and improve', //  fine tuning
//     benefits: [
//       'Google Analytics and Ad Tracking platforms',
//       '50 Pages',
//       '50 Rich links per page',
//     ]
//   },
//   agency: {
//     row_idx: 3,
//     price: 99.0,
//     annual_price: 594.0,//990.0,
//     annual_then_price: plans['agency'].annual_price,
//     name: "Agency",
//     description: 'Projects and Teams',
//     // stripe_id: 'agency2019',
//     benefits: [
//       '3+ projects',
//       '10 team members per project',
//       '250 Pages',
//     ]
//   }
// }
// 
export default (window.BF2019_SALE ? plansBF2019 : plans);


// WEBPACK FOOTER //
// ./src/components/billing/plans.js